<template>
    <div>
        <h2>What's On Today</h2>
        <program
            v-for="program in programs_today"
            :key="program.title"
            :program="program"
        />
        <div class="notice-text" v-if="programs_today.length === 0">오늘은 프로그램이 없어요!</div>
        <h2>Schedule</h2>
        <calender
            :timetable = timeTable
            :times = sortedKey
        />
    </div>
</template>

<script>
import Calender from '@/components/Calender.vue';
import Program from '@/components/Program.vue';
import regularData from '@/data/schedule.js';

export default {
    name: "Schedule",
    data: function() {
        return {
            timeTable: {},
            sortedKey: [],
            programs_today: [],
        }
    },
    components: {
        Calender,
        Program,
    },
    created: function() {
        const by_time = {};
        for ( const program of regularData ) {
            const time = program.date_time;
            if ( Object.keys(by_time).includes( time ) ) {
                by_time[ time ].push(program);
            } else {
                by_time[ time ] = [program, ];
            }
        }
        this.timeTable = by_time;
        this.sortedKey = Object.keys(by_time).sort();

        const today = new Date();
        const today_week = today.getDay();
        const list = [];
        for ( const time of this.sortedKey ) {
            for ( const program of this.timeTable[time] ) {
                if ( program.date_week === today_week ) {
                    list.push( program );
                }
            }
        }
        this.programs_today = list;
    },
}
</script>

<style lang="scss" scoped>
</style>
